module.exports = __webpack_public_path__ + "img/icon-customer.4b2f7e7a.svg";